<template>
  <main class="l-main" v-bind="$attrs" >
    <slot />
  </main>
</template>

<script>

export default {
  name: 'LMain',
}

</script>
<style>
.l-main {
  width: 100%;
  /*all: initial;*/
  margin-left: var(--side-w);
  /*transition: .2s all;*/
  margin-top: var(--topb-h);
  
  /*background: #f3f3f4;*/
/*  padding: var(--main-pad);*/
/*  background-color: #f3f3f4;*/

  > * {
    &.fade-enter {
      transform: translateY(-50px);
    }

    &.fade-leave-to {
      transform: translateY(50px);
    }

    &.fade-enter-to, &.fade-leave {
      transform: translateY(0px);
    }
  }

  .Table th { top: var(--topb-h) }
}

.t-sidebar-mini .l-main {
  margin-left: var(--side-mini-w);
}

#page-wrapper .l-main {
  padding: var(--main-pad) 0;
  margin-top: 0;
  margin-left: 0;
}
</style>